export const sortRowsByIdDesc = rows => {
  const sorted = Array.isArray(rows) ? [...rows] : [];
  sorted.sort((a, b) => (Number(a.id) > Number(b.id) ? -1 : 1));
  return sorted;
};
